module.exports = __webpack_public_path__ + "static_1727318417925/img/openup_new.61d1c43f.png";